import { AuthServiceClient } from '@playq/octopus2-auth';

import { transport } from '../../core';

export const authService = new AuthServiceClient(transport);
